if (!customElements.get('ia-minicart-favorites')) {
  class IaMinicartFavorites extends HTMLElement {
    async connectedCallback() {
      const cartContainer = document.getElementById('CartContainer')
      if (!cartContainer) return

      new MutationObserver(() => this._injectAndFilter())
        .observe(cartContainer, { childList: true })

      document.addEventListener('cartdrawer:refresh', () => this._injectAndFilter())

      await this._fetchContent()
    }

    async _fetchContent() {
      try {
        // 1. Fetch server-rendered recent order slides + wrapper
        const favRes = await fetch('/?section_id=ia-minicart-favorites-section')
        if (!favRes.ok) return
        const favDoc = new DOMParser().parseFromString(await favRes.text(), 'text/html')
        const favSection = favDoc.getElementById('shopify-section-ia-minicart-favorites-section')
        if (!favSection?.querySelector('.ia-minicart-favorites')) return

        // 2. Fetch recommendation slides and append into swiper-wrapper
        const productId = favSection.querySelector('[data-reco-product-id]')?.dataset?.recoProductId
        if (productId) {
          const recoRes = await fetch(
            `/recommendations/products?product_id=${productId}&limit=6&section_id=ia-minicart-favorites-section&intent=related`
          )
          if (recoRes.ok) {
            const recoDoc = new DOMParser().parseFromString(await recoRes.text(), 'text/html')
            const recoSection = recoDoc.getElementById('shopify-section-ia-minicart-favorites-section')
            if (recoSection) {
              const existingIds = new Set(
                [...favSection.querySelectorAll('[data-product-id]')].map(el => el.dataset.productId)
              )
              console.log('[ia-minicart-favorites] existing IDs from recent order:', [...existingIds])
              const wrapper = favSection.querySelector('.swiper-wrapper')
              recoSection.querySelectorAll('.swiper-slide').forEach(slide => {
                const card = slide.querySelector('[data-product-id]')
                const id = card?.dataset?.productId
                if (!id) {
                  console.log('[ia-minicart-favorites] reco slide has no data-product-id — appending anyway')
                  wrapper?.insertAdjacentHTML('beforeend', slide.outerHTML)
                } else if (existingIds.has(id)) {
                  console.log('[ia-minicart-favorites] skipping duplicate reco product:', id)
                } else {
                  console.log('[ia-minicart-favorites] appending reco product:', id)
                  wrapper?.insertAdjacentHTML('beforeend', slide.outerHTML)
                }
              })
            }
          }
        }

        this._html = favSection.innerHTML
        this._injectAndFilter()
      } catch (e) {
        // non-critical — skip silently
      }
    }

    async _injectAndFilter() {
      const slot = document.getElementById('ia-minicart-favorites-slot')
      if (!slot || !this._html) return

      // Fetch cart before setting innerHTML to avoid a flash of unfiltered slides
      const cart = await fetch('/cart.js').then(r => r.json()).catch(() => ({ items: [] }))
      const cartProductIds = new Set(cart.items.map(i => i.product_id))

      slot.innerHTML = this._html
      this._applyFilter(slot, cartProductIds)

      // Defer Swiper init to next frame — ensures the drawer is visible and
      // the slider container has non-zero dimensions before Swiper reads them
      requestAnimationFrame(() => this._initSwiper(slot))
    }

    _applyFilter(slot, cartProductIds) {
      const slides = [...slot.querySelectorAll('.swiper-slide')]
      let visible = 0
      slides.forEach(slide => {
        const card = slide.querySelector('[data-product-id]')
        const productId = card ? parseInt(card.dataset.productId, 10) : null
        const inCart = productId !== null && cartProductIds.has(productId)
        const overLimit = visible >= 6
        slide.hidden = inCart || overLimit
        if (!inCart && !overLimit) visible++
      })
      const wrapper = slot.querySelector('.ia-minicart-favorites')
      if (wrapper) wrapper.hidden = visible === 0
    }

    _initSwiper(slot) {
      if (typeof Swiper === 'undefined') return
      const el = slot.querySelector('.ia-minicart-favorites__swiper')
      if (!el) return
      new Swiper(el, {
        slidesPerView: 1.7,
        spaceBetween: 10,
        loop: false,
        preventClicks: false,
        preventClicksPropagation: false,
        a11y: false,
        breakpoints: {
          1024: { slidesPerView: 2.2 },
        },
      })
    }
  }

  customElements.define('ia-minicart-favorites', IaMinicartFavorites)
}
